import type { CSSProperties } from 'react';

// Heroicons-style stroke icons, inline for zero dependency weight.
// Add new paths as needed.

type IconName =
  | 'grid' | 'briefcase' | 'check-list' | 'calendar' | 'users' | 'balance-scale'
  | 'receipt' | 'book-open' | 'price-tag' | 'document' | 'pen' | 'shield-check'
  | 'cog' | 'shield-star' | 'search' | 'bell' | 'user' | 'chevron-down' | 'logout'
  | 'sun' | 'moon' | 'pin' | 'sparkle' | 'mail' | 'credit-card' | 'globe'
  | 'plus' | 'x';

const ICONS: Record<IconName, React.ReactNode> = {
  grid: (<><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /></>),
  briefcase: (<><rect x="3" y="7" width="18" height="13" rx="2" /><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /><path d="M3 13h18" /></>),
  'check-list': (<><path d="M9 6h11" /><path d="M9 12h11" /><path d="M9 18h11" /><path d="M4 6l1 1 2-2" /><path d="M4 12l1 1 2-2" /><path d="M4 18l1 1 2-2" /></>),
  calendar: (<><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 9h18" /><path d="M8 3v4" /><path d="M16 3v4" /></>),
  users: (<><circle cx="9" cy="8" r="4" /><path d="M2 20c0-3.866 3.134-7 7-7s7 3.134 7 7" /><path d="M17 11a3 3 0 1 0 0-6" /><path d="M22 20a5 5 0 0 0-5-5" /></>),
  'balance-scale': (<><path d="M12 3v18" /><path d="M5 7h14" /><path d="M5 7l-3 6a3 3 0 0 0 6 0L5 7z" /><path d="M19 7l-3 6a3 3 0 0 0 6 0l-3-6z" /><path d="M8 21h8" /></>),
  receipt: (<><path d="M6 2h12v20l-3-2-3 2-3-2-3 2V2z" /><path d="M9 7h6" /><path d="M9 11h6" /><path d="M9 15h4" /></>),
  'book-open': (<><path d="M2 5a2 2 0 0 1 2-2h6v17H4a2 2 0 0 1-2-2V5z" /><path d="M22 5a2 2 0 0 0-2-2h-6v17h6a2 2 0 0 0 2-2V5z" /></>),
  'price-tag': (<><path d="M20.6 11.4l-8.7 8.7a2 2 0 0 1-2.8 0l-6.3-6.3a2 2 0 0 1 0-2.8l8.7-8.7A2 2 0 0 1 12.9 2H19a2 2 0 0 1 2 2v6.1a2 2 0 0 1-.4 1.3z" /><circle cx="16" cy="8" r="1" /></>),
  document: (<><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" /><path d="M14 2v6h6" /><path d="M8 13h8" /><path d="M8 17h8" /></>),
  pen: (<><path d="M12 20h9" /><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" /></>),
  'shield-check': (<><path d="M12 2l8 3v6c0 5-3.5 9.5-8 11-4.5-1.5-8-6-8-11V5l8-3z" /><path d="M9 12l2 2 4-4" /></>),
  cog: (<><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3h.1a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8v.1a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" /></>),
  'shield-star': (<><path d="M12 2l8 3v6c0 5-3.5 9.5-8 11-4.5-1.5-8-6-8-11V5l8-3z" /><path d="M12 8l1.5 3 3.2.3-2.4 2.1.7 3.2L12 15l-2.9 1.6.7-3.2L7.3 11.3 10.5 11z" /></>),
  search: (<><circle cx="11" cy="11" r="7" /><path d="M20 20l-3-3" /></>),
  bell: (<><path d="M6 19h12l-1.5-2V11a4.5 4.5 0 1 0-9 0v6L6 19z" /><path d="M10 22h4" /></>),
  user: (<><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 4-6 8-6s8 2 8 6" /></>),
  'chevron-down': (<><path d="M6 9l6 6 6-6" /></>),
  logout: (<><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="M16 17l5-5-5-5" /><path d="M21 12H9" /></>),
  sun: (<><circle cx="12" cy="12" r="4" /><path d="M12 2v2" /><path d="M12 20v2" /><path d="M5 5l1.5 1.5" /><path d="M17.5 17.5L19 19" /><path d="M2 12h2" /><path d="M20 12h2" /><path d="M5 19l1.5-1.5" /><path d="M17.5 6.5L19 5" /></>),
  moon: (<><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" /></>),
  pin: (<><path d="M12 22s-7-7-7-12a7 7 0 1 1 14 0c0 5-7 12-7 12z" /><circle cx="12" cy="10" r="2.5" /></>),
  sparkle: (<><path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3z" /></>),
  mail: (<><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" /></>),
  'credit-card': (<><rect x="2" y="5" width="20" height="14" rx="2" /><path d="M2 10h20" /></>),
  globe: (<><circle cx="12" cy="12" r="9" /><path d="M3 12h18" /><path d="M12 3a14 14 0 0 1 0 18" /><path d="M12 3a14 14 0 0 0 0 18" /></>),
  plus: (<><path d="M12 5v14" /><path d="M5 12h14" /></>),
  x:    (<><path d="M6 6l12 12" /><path d="M18 6L6 18" /></>),
};

type IconProps = {
  name: IconName;
  size?: number;
  style?: CSSProperties;
  stroke?: number;
};

export default function Icon({ name, size = 18, style, stroke = 1.8 }: IconProps) {
  const content = ICONS[name];
  if (!content) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0, display: 'inline-block', ...style }}
    >
      {content}
    </svg>
  );
}
